declare global {
  // eslint-disable-next-line
  interface Array<T> {
    unique(): Array<T>;
    sortBy(property: string): Array<T>;
    sumTime(): string;
  }
}

// eslint-disable-next-line no-extend-native
Array.prototype.unique = function () {
  const arr: any[] = [];
  for (let i = 0; i < this.length; i++) {
    if (!arr.includes(this[i])) {
      arr.push(this[i]);
    }
  }
  return arr;
};

function dynamicSort(property: string) {
  let sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a: any, b: any) {
    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    const result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}

// eslint-disable-next-line no-extend-native
Array.prototype.sortBy = function (property: string) {
  return this.sort(dynamicSort(property));
};

// eslint-disable-next-line no-extend-native
Array.prototype.sumTime = function () {
  const onlyNonNulls = this.filter(
    (time: any) => time !== null && time !== undefined,
  );
  if (
    onlyNonNulls.some((time: any) => {
      return typeof time !== "string" || !/^[0-9]{0,10}:[0-5][0-9]$/.test(time);
    })
  ) {
    console.warn(
      "Invalid time array! All elements must be in the format HH:mm",
    );
  }

  let hours = 0,
    minutes = 0;

  onlyNonNulls.forEach((time: string) => {
    const split = time.split(":");
    hours += parseInt(split[0]);
    minutes += parseInt(split[1]);
  });
  const formattedNumber3 = (num: number) => ("0" + num).slice(-3);
  const formattedNumber2 = (num: number) => ("0" + num).slice(-2);
  hours += Math.floor(minutes / 60);
  minutes = minutes % 60;

  const hoursformatted =
    hours > 99 ? formattedNumber3(hours) : formattedNumber2(hours);

  return hoursformatted + ":" + formattedNumber2(minutes);
};
export default {};
